<template>
    <div class="hallmark-signature-deluxe-question">
        <div class="hallmark-signature-deluxe-question-banner">
            <div class="image">
                <img :src="'https://tranquility-dev.s3.eu-west-2.amazonaws.com/fabricator_uploads/8/signature-deluxe-designer-logo.png'" />
            </div>
            <div class="tagline">
                <div>
                    STAND OUT FROM THE CROWD AND UPGRADE YOUR DOOR.
                </div>
                <div>
                    ENHANCED SECURITY. STUNNING DESIGN OPTIONS. A SOLID INVESTMENT.
                </div>
            </div>
            <div class="logos">
                <div>
                    <img :src="'https://tranquility-dev.s3.eu-west-2.amazonaws.com/fabricator_uploads/8/signature-deluxe-logo-2.png'">
                </div>
                <div>
                    <img :src="'https://tranquility-dev.s3.eu-west-2.amazonaws.com/fabricator_uploads/8/signature-deluxe-logo-3.png'">
                </div>
                <div>
                    <img :src="'https://tranquility-dev.s3.eu-west-2.amazonaws.com/fabricator_uploads/8/signature-deluxe-logo-4.png'">
                </div>
                <div>
                    <img :src="'https://tranquility-dev.s3.eu-west-2.amazonaws.com/fabricator_uploads/8/signature-deluxe-logo-1.png'">
                </div>
                <div>
                    <img :src="'https://tranquility-dev.s3.eu-west-2.amazonaws.com/fabricator_uploads/8/signature-deluxe-logo-5.png'">
                </div>
                <div>
                    <img :src="'https://tranquility-dev.s3.eu-west-2.amazonaws.com/fabricator_uploads/8/signature-deluxe-logo-6.png'">
                </div>
                <div>
                    <img :src="'https://tranquility-dev.s3.eu-west-2.amazonaws.com/fabricator_uploads/8/signature-deluxe-logo-7.png'">
                </div>
                <div>
                    <img :src="'https://tranquility-dev.s3.eu-west-2.amazonaws.com/fabricator_uploads/8/signature-deluxe-logo-8.png'">
                </div>
                <div>
                    <img :src="'https://tranquility-dev.s3.eu-west-2.amazonaws.com/fabricator_uploads/8/signature-deluxe-logo-9.png'">
                </div>
                <div>
                    <img :src="'https://tranquility-dev.s3.eu-west-2.amazonaws.com/fabricator_uploads/8/signature-deluxe-logo-10.png'">
                </div>
            </div>
        </div>
        <div :id="'radio--' + component_id" class="hallmark-signature-deluxe-question-options">
            <div v-if="options_loaded && passed_filter">
                <div class="radiooption stylesoption" v-if="!loading" :data-designer-component-id="component_id">
                    <span>{{ title }}</span>
                    <span v-for="option in filtered_option_list"><label><input type="radio" v-model="localTarget"
                                                                               :name="'radio_' + component_id"
                                                                               :value="option.value"/> {{ option.label }}</label></span>
                </div>
                <div v-if="loading">
                    <p>Loading Options</p>
                </div>
            </div>
            <div class="align-center pb-3">
                Choosing this option may remove some design options
            </div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    import DesignerQuestionCollection from "../DesignerQuestionCollection.vue";

    export default {
        mixins: [
            DesignerQuestionCollection
        ],
        props: {
            component_id: {
                default(){
                    return 'signature_deluxe';
                }
            },
        },
    }
</script>
